<style scoped>
	#map{
		position: fixed;
		top:0;
		left:0;
		width: 100%;
		height: 100%;
		z-index: 99999;
		background-color: rgba(0,0,0,.2);
	}
	.layout{
		width:830px;
		margin:80px auto 0;
		border-radius: 3px;
		overflow: hidden;
		box-shadow: 0 0 5px rgba(0,0,0,.5);
	}
</style>
<template>
	<div id="map">
		<div class="layout">
			<div class="panel panel-default m0">
		  		<div class="panel-heading">
		  			<div class="row">
						<div class="col-xs-6 ptb4" >
				            <span class="cae bk bk-green">
				            选取经纬度坐标</span>
				        </div>
						<div class="col-xs-6">
							<div class="input-group pr15">
						      <input type="text" class="form-control" placeholder="输入要查询的地址" v-model="text">
						      <span class="input-group-btn">
						        <button class="btn btn-default" type="button" @click="search">查询</button>
						      </span>
						    </div><!-- /input-group -->
						</div>
					</div>	
		  		</div>
		  		<div class="panel-body">
			        <div id="container" style="width: 800px;height: 400px; overflow:hidden;">
			        </div>
		        </div>
  				<div class="panel-footer ">
  					<div class="row">
	  					<div class="col-sm-8">  						
				        	<label class="ptb4 pl15">选取的坐标: {{point}}</label>
	  					</div>
	  					<div class="col-sm-4">
					        <div class="form-group pull-right m0 pr15">
							      <button type="button" class="btn btn-default" @click="close">
							      	关闭
							      </button>
							      <button type="button" class="btn btn-primary" v-on:click="close">
							      	确定选择
							      </button>
							</div>
						</div>
					</div>
  				</div>
  			</div>
		</div>
	</div>
</template>
<script>
	// require('http://api.map.baidu.com/api?v=1.3');
	var BMapLib = require('../utils/BMap.js');
	var currPoint = null;//当前指向的坐标
	module.exports = {		
		data : function(){
			return {
				text : '',//查询的文本
				point : 'X:--,Y--',//坐标
				map : null
			}
		},
		ready : function(){
			var self = this;
			if(currPoint == null){ //设置默认的坐标
				currPoint = new BMap.Point(104.08329,30.662055);
			}
			this.point = 'X:' + currPoint.lng  + ",Y:" + currPoint.lat;			
			//创建地图
			this.map = new BMapLib({
			    container : 'container',
			    city : currPoint,
			    //查询和点击标注都会调用这个
			    callback : function(x,y){
			    	currPoint = new BMap.Point(x,y);
			        self.point = "X:" + x + ",Y:" + y;
			        //坐标改变的分发
					self.$dispatch('pointChange', self.point);		
			    }
			});
			//设置地图默认的标注
			this.map.setMarker(currPoint);
		},
		methods : {
			search : function(){
				this.map.searchByStationName(this.text);
			},
			close : function(){
				this.$dispatch('mapClose');	
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** Map.vue?71379aa9
 **/